export const NO_MEMBER_TAG_VALUE = '--null--'; // player use the same convintion
